import BaseSecondaryStickyView from "scripts/views/baseSecondaryStickyNavView";

class BaseContentDetailsPageNavView extends BaseSecondaryStickyView {
  updateLinkState() {
    const subPageType = this.model.get("subPageType");

    if (subPageType === "details") {
      $("#bb-content-details-page-nav-item-details").addClass("active");
      $("#bb-content-details-page-nav-heading-details").addClass("active");
    } else if (subPageType === "chapters") {
      $("#bb-content-details-page-nav-item-chapters").addClass("active");
      $("#bb-content-details-page-nav-heading-chapters").addClass("active");
    } else if (subPageType === "notes") {
      $("#bb-content-details-page-nav-item-notes").addClass("active");
      $("#bb-content-details-page-nav-heading-notes").addClass("active");
    } else if (subPageType === "comments") {
      $("#bb-content-details-page-nav-item-comments").addClass("active");
      $("#bb-content-details-page-nav-heading-comments").addClass("active");
    } else if (subPageType === "citations") {
      $("#bb-content-details-page-nav-item-citations").addClass("active");
      $("#bb-content-details-page-nav-heading-citations").addClass("active");
    } else if (subPageType === "also-found-in") {
      $("#bb-content-details-page-nav-item-also-found-in").addClass("active");
    }
  }
}

export default BaseContentDetailsPageNavView;
